export enum ResendInviteWithPasswordFormFields {
  Password = 'password',
  PasswordConfirm = 'password_confirm',
}

export type ResendInviteWithPasswordFormModel = {
  [ResendInviteWithPasswordFormFields.Password]: string;
  [ResendInviteWithPasswordFormFields.PasswordConfirm]: string;
};

export enum PasswordValidationRuleNames {
  atLeastTenCharacters = 'atLeastTenCharacters',
  atLeastOneNumber = 'atLeastOneNumber',
  atLeastOneLowerCaseLetter = 'atLeastOneLowerCaseLetter',
  atLeastOneUpperCaseLetter = 'atLeastOneUpperCaseLetter',
  atLeastOneSpecialCharacter = 'atLeastOneSpecialCharacter',
  passwordsEqual = 'passwordsEqual',
}

export type PasswordsValidation = Partial<Record<PasswordValidationRuleNames, boolean>>;

export type PasswordValidationMessages = Record<
  PasswordValidationRuleNames,
  {
    text: string;
    isValid: boolean;
  }
>;
